import { render, staticRenderFns } from "./AdressField.vue?vue&type=template&id=99fa8638&scoped=true"
import script from "./AdressField.vue?vue&type=script&lang=js"
export * from "./AdressField.vue?vue&type=script&lang=js"
import style0 from "./AdressField.vue?vue&type=style&index=0&id=99fa8638&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99fa8638",
  null
  
)

export default component.exports